import { useContext } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { GameContext } from '../../App'
import Card from './Card'
import CardData from '../../game/Card'

const CenteredRow = styled.div`
    display: flex;
    justify-content: center;
`

const SelectionHalo = styled.div`
    pading: 0;
    margin: 0;
    border: 2px solid blue;
`

function PlayerHand({ selected, setSelected }) {
    const { gameState } = useContext(GameContext)

    return (
        <CenteredRow>
            {gameState.hand.map((card, index) => {
                const cardComponent = (
                    <Card 
                        key={index}
                        data={card} 
                        onClick={() => setSelected(card)}
                    />
                )
                return ( selected === card ? 
                    <SelectionHalo key={index}>{cardComponent}</SelectionHalo> :
                    cardComponent
                )
            })}
        </CenteredRow>
    )
}

PlayerHand.propTypes = {
    selected: PropTypes.instanceOf(CardData),
    setSelected: PropTypes.func.isRequired    
}

export default PlayerHand